import { useTranslation } from 'react-i18next';
import { Link, Navigate } from 'react-router';
import { useTypedSearchParams, useTypedState } from 'react-router-typesafe-routes';
import { SignInForm, type SignInFormData } from '@/components/auth/sign-in-form';
import { BrandLogo } from '@/components/common/brand-logo';
import useSignIn from '@/hooks/auth/use-sign-in';
import ROUTES from '@/routes';

export default function SignInRoute() {
  const { t } = useTranslation();
  const [{ phone, redirect }] = useTypedSearchParams(ROUTES.AUTH.SIGN_IN);
  const state = useTypedState(ROUTES.AUTH.SIGN_IN);
  const { signIn, isPending, isSignedIn } = useSignIn();

  const handleSubmit = (data: SignInFormData, withOtp = false) =>
    signIn({
      Phone: data.phoneNumber,
      TelCode: data.countryCode,
      Password: data.password,
      WithOtp: withOtp,
    });

  if (isSignedIn) {
    return (
      <Navigate
        replace
        to={redirect ? decodeURIComponent(redirect) : ROUTES.MESSAGES.$path()}
      />
    );
  }

  return (
    <div className='flex flex-1 flex-col'>
      <div className='flex-1 flex flex-col justify-center'>
        <BrandLogo
          fetchPriority='high'
          variant='simple'
          className='mx-auto brand-ryuryu:h-40 h-30'
        />
      </div>
      <div className='mx-12 mb-16 flex h-full flex-col max-h-60vh 4xl:max-h-40vh items-stretch first:mt-safe-offset-16 flex-1'>
        <SignInForm
          isLoading={isPending}
          disabled={isSignedIn}
          navigateBack={state.from === 'switch'}
          onSubmit={handleSubmit}
        />

        <div className='mt-4 flex justify-center'>
          <Link
            className='link-hover link link-neutral'
            to={ROUTES.AUTH.SIGN_UP.$buildPath({ searchParams: { phone } })}>
            {t('auth.sign-up-now')}
          </Link>
        </div>
      </div>
    </div>
  );
}
